/**
 * @file System base class.
 *
 * A system is the only place where behaviour is allowed to live. It reads and
 * writes components, never touching Three.js objects except through the
 * dedicated rendering systems.
 *
 * Lifecycle: `init()` once when registered, `update(dt)` every frame while
 * `enabled`, `dispose()` when the world tears down.
 */

export class System {
  /** Lower values run earlier within a world update. */
  static priority = 0;

  constructor() {
    /** @type {import('./World.js').World | null} */
    this.world = null;
    /** @type {import('../core/Context.js').GameContext | null} */
    this.ctx = null;
    /** @type {boolean} Systems can be toggled without being unregistered. */
    this.enabled = true;
  }

  /**
   * Injects dependencies. Called by the world before {@link System#init}.
   * @param {import('./World.js').World} world Owning world.
   * @param {import('../core/Context.js').GameContext} ctx Shared game context.
   * @returns {void}
   * @internal
   */
  _attach(world, ctx) {
    this.world = world;
    this.ctx = ctx;
  }

  /**
   * One-time setup: cache queries, subscribe to events.
   * @returns {void}
   */
  init() {}

  /**
   * Per-frame behaviour.
   * @param {number} _dt Delta time in seconds, already clamped.
   * @returns {void}
   */
  update(_dt) {}

  /**
   * Releases resources and event subscriptions.
   * @returns {void}
   */
  dispose() {}
}
